// extracted by css-extract-rspack-plugin
export default {"text":"text-U5mIpK","line":"line-DvS3ee"};